/**
 * 招标管理
 */
const computedArr = function (arr, dept, handleDept) {
  for (let item of arr) {
    if (item.id === handleDept) {
      dept.deptName = item.name
    }
    if (item.children && item.children.length > 0) {
      computedArr(item.children, dept, handleDept)
    }
  }
}
export default {
  state: {
    status: 'NONE', // NONE ADD EDIT 分别对应列表，新增，编辑状态
    baseInfoFormInList: {}, // 主表基本信息
    tenderDetailList: [], // 表体信息列表
    accessoryInfo: [], // 附件信息列表
    handler: '', // 经办人
    handleDept: '', // 经办部门
    projectInfo: [], // 项目信息
    tenderDelIdList: [],
    orgList: [], // 组织
    userOption: [], // 经办人列表
    deptData: [], // 经办部门列表
  },
  mutations: {
    /**
     * 更新编辑状态
     */
    statusMt (state, newVal) {
      state.status = newVal
    },
    /**
     * 基本信息更新
     */
    baseInfoFormInListMt (state, newVal) {
      state.baseInfoFormInList = newVal
    },
    /**
     * 表体信息列表更新
     */
    tenderDetailListMt (state, newVal) {
      state.tenderDetailList = newVal
    },
    /**
     * 表体信息列表新增
     */
    tenderDetailListAdd (state, newVal) {
      state.tenderDetailList.push(newVal)
    },
    /**
     * 表体信息列表删除
     */
    tenderDetailListDel (state, index) {
      state.tenderDetailList.splice(index, 1)
    },
    /**
     * 附件信息列表更新
     */
    accessoryInfoMt (state, newVal) {
      state.accessoryInfo = newVal
    },
    /**
     * 经办人更新
     */
    handlerMt (state, newVal) {
      state.handler = newVal
    },
    /**
     * 经办部门更新
     */
    handleDeptMt (state, newVal) {
      state.handleDept = newVal
    },
    /**
     * 项目信息更新
     */
    projectInfoMt (state, newVal) {
      state.projectInfo = newVal
    },
    /**
     * 组织信息更新
     */
    orgListMt (state, newVal) {
      state.orgList = newVal
    },
    /**
     * 要删除的表体行
     * */
    tenderDelIdListMt (state, newVal) {
      state.tenderDelIdList = newVal
    },
    /**
     * 更新经办人列表
     * */
    userOptionMt (state, newVal) {
      state.userOption = newVal
    },
    /**
     * 更新经办部门列表
     * */
    deptDataMt (state, newVal) {
      state.deptData = newVal
    }
  },
  actions: {
    handlerAct ({commit}, vm) { // actions中的函数作用域独立于vue
      const promise1 = new Promise(resolve => {
        vm.$http.post(vm.api.sysUserQueryById + sessionStorage.getItem('userId')).then(res => {
          if (res.data.code === '200') {
            commit('handlerMt', res.data.body.id)
            resolve(res.data.body.id)
          }
        })
      })
      const promise2 = new Promise(resolve => {
        vm.$http.get(vm.api.deptEdit + '/' + sessionStorage.getItem('deptId')).then(res => {
          if (res.data.code === '200') {
            commit('handleDeptMt', res.data.body.id)
            resolve(res.data.body.id)
          }
        })
      })
      return Promise.all([promise1, promise2])
    },
    handleTenderUserInfo ({commit}, vm) {
      //获取用户下拉列表数据
      vm.$http.get(vm.api.queryAllUser).then(res => {
        if (res.data.code === "200") {
          commit('userOptionMt', res.data.body)
        } else {
          vm.$message.warning(res.data.body);
        }
      });
      //获取部门下拉列表数据
      vm.$http.post(vm.api.deptTree).then(res => {
        if (res.data.code === "200") {
          commit('deptDataMt', res.data.body)
        } else {
          vm.$message.warning(res.data.body);
        }
      });
    }
  },
  getters: {
    getTenderHandleName: ({userOption}) => handler => {
      for (let item of userOption) {
        if (item.id === handler) {
          return item.userName
        }
      }
    },
    getTenderHandleDept: ({deptData}) => handleDept => {
      let dept = {
        deptName: ''
      }
      for (let item of deptData) {
        if (item.id === handleDept) {
          return item.name
        }
        if (item.children && item.children.length > 0) {
          computedArr(item.children, dept, handleDept)
        }
      }
      return dept.deptName
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/tender.js